import { DefaultTheme } from "react-native-paper";
import { Theme } from "react-native-paper/lib/typescript/types";

const theme: Theme = {
	...DefaultTheme,
	colors: {
		...DefaultTheme.colors,
		primary: "#40b8b8",
		accent: "yellow",
		background: "#f5f5f5",
		text: "#868686",
		error: "#FF0404",
		danger: "#B20000",
		inputBackgroundColor: "rgba(199,210,209,0.3)",
	},
};

export default theme;
